// extracted by mini-css-extract-plugin
export default {"heading":"heading__ZGRjY","strong":"strong__ZDg1Y","h1":"h1__ZjM3Y","h2":"h2__MDg2M","h3":"h3__MGE3O","h4":"h4__ZTdmM","h5":"h5__Y2FkM","h6":"h6__MjgxM"};